import { Module } from "vuex";
import { RootState } from "../types";
import { MaintenancejobsState } from "./types";

import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

import { Maintenancejob } from '@/models';

// Default state
export const state: MaintenancejobsState = {
	current: new Maintenancejob(),
	list: [],
	month: undefined,
	search: undefined,
	updates: [],
	currentPage: 1,
	pageLimit: 20,
	filterCustomer: undefined,
	filterStatus: undefined,
	filterContractor: undefined,

}

// User namespaced Vuex modules
const namespaced: boolean = true;

// Module export
const customers: Module<MaintenancejobsState, RootState> = {
	state,
	getters,
	mutations,
	actions,
	namespaced,
}

export default customers;